module.exports = __webpack_public_path__ + "img/jellybean_sonic.9467c51e.png";